import React, { useState, useEffect, useCallback, useRef } from "react";
import Loader from "../../components/Loader";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import {
    Box, Typography, TextField, TableContainer, Paper,
    MenuItem, Button, Table, TableHead, TableRow,
    TableCell, TableBody, InputAdornment, Checkbox,
    FormControlLabel, Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Icon,
    CircularProgress,
    Link,
    Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Delete, Cancel } from "@mui/icons-material";
import { useFillList } from "../../components/fillList";
import { dashboardActiveActionID, dashboardGroupActionID, dashboardRoleActionID, GetDashboardUrl, GetUserShareAccessUrl, InsertDashboardUrl, SearchUserAndADGroupUrl, SendMailNotificationUrl, UpdateDashboardUrl, servicePrincipalActionID } from "../../utils/constants";
import { axiosGet, axiosPost } from "../../utils/Axios";
import CommonPagination from "../../components/CommonPagination";
import { useToast } from "../../components/toast";
import moment from 'moment';
import _ from 'lodash';
import { HeaderBlock } from "@colliers/colliers-b2c";
import {
    buildDashboardUserFromSearch,
    findExistingDashboardUser,
    mergeInvitedUsersIntoGroupList,
    partitionInvitedUsers,
    resolveDashboardRoleID,
    shouldCheckInactiveBeforeAdding,
    splitUsersByInactiveStatus
} from "./inactiveClientHelper";

const DashboardAdd = () => {
    const getNextYearDate = () => {
        const today = new Date();
        const nextYear = new Date(today.setFullYear(today.getFullYear() + 1));
        return nextYear.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    //toast
    const { ToastComponent, showToast } = useToast();
    //navigate
    const navigate = useNavigate();
    const location = useLocation();
    const [dashboardID] = useState(() => location.state?.dashboardID ?? null);
    //pop
    const [isRemoveUserModal, setRemoveUserModal] = useState(false);
    const [removeUserIndex, setRemoveUserIndex] = useState('');
    //conditional
    const [isLoading, setIsLoading] = useState(false);
    const [isUserLoading, setIsUserLoading] = useState(false);
    const [isInvite, setIsInvite] = useState(false);
    const [canShareClient, setCanShareClient] = useState(false);
    const [canShareColliers, setCanShareColliers] = useState(false);
    //state
    const [titleLocal, setTitleLocal] = useState("");
    const [titleEnglish, setTitleEnglish] = useState("");
    const [clientNameLocal, setClientNameLocal] = useState("");
    const [clientNameEnglish, setClientNameEnglish] = useState("");
    const [dashboardGroupID, setDashboardGroupID] = useState("");
    const [workspaceName, setWorkspaceName] = useState("");
    const [workspaceID, setWorkspaceID] = useState("");
    const [reportName, setReportName] = useState("");
    const [reportID, setReportID] = useState("");
    const [field1, setField1] = useState("");
    const [field2, setField2] = useState("");
    const [imageFileName, setImageFileName] = useState(null);
    const [imagePath, setImagePath] = useState(null);
    const [isRLS, setIsRLS] = useState(true);
    const [ServicePrincipalID, setServicePrincipalID] = useState("");
    const [Status, setStatus] = useState("1");
    const [, setIsAlteredImage] = useState(false);
    const [isUDTUserDataChanged, setIsUDTUserDataChanged] = useState(false);
    //validator
    const [TitleLocalErr, setTitleLocalErr] = useState("");
    const [TitleEnglishErr, setTitleEnglishErr] = useState("");
    const [ClientNameLocalErr, setClientNameLocalErr] = useState("");
    const [ClientNameEnglishErr, setClientNameEnglishErr] = useState("");
    const [DashboardGroupIDErr, setDashboardGroupIDErr] = useState("");
    const [WorkspaceIDErr, setWorkspaceIDErr] = useState("");
    const [ReportIDErr, setReportIDErr] = useState("");
    const [StatusErr, setStatusErr] = useState("");
    const [GroupnUserListErr, setGroupnUserListErr] = useState("");
    const [ServicePrincipalIDErr, setServicePrincipalErr] = useState("");

    //invite
    const [inviteEmail, setInviteEmail] = useState('');
    const [inviteValidUntil, setInviteValidUntil] = useState(getNextYearDate());
    const [inviteRls, setInviteRls] = useState('');
    const [isReactivateModalOpen, setIsReactivateModalOpen] = useState(false);
    const [pendingInviteUsers, setPendingInviteUsers] = useState([]);
    //fillList
    const [DashboardGroupFillList, setDashboardGroupFillList] = useState([]);
    const [DashboardRoleFillList, setDashboardRoleFillList] = useState([]);
    const [DashboardActiveFillList, setDashboardActiveFillList] = useState([]);
    const [DashboardServicePrincipalFillList, setServicePrincipalFillList] = useState([]);

    const groupFillList = useFillList(dashboardGroupActionID, "", ""); // Action ID 3
    const roleFillList = useFillList(dashboardRoleActionID, "", ""); // Action ID 4
    const ActiveFillList = useFillList(dashboardActiveActionID, "", ""); // Action ID 4
    const servicePrincipalFillList = useFillList(servicePrincipalActionID, "", ""); // Action ID 9

    //group and user
    const [inputValue, setInputValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState('');
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [DashboardUserData, setDashboardUserData] = useState([]);
    const [userCurrentPage, setUserCurrentPage] = useState(1);
    const searchAbortControllerRef = useRef(null);
    const searchRequestIdRef = useRef(0);
    const [GroupnUserList, setGroupnUserList] = useState([]);
    const userItemsPerPage = 10;
    const totalUserItems = DashboardUserData?.length || 0;
    const userStartIndex = (userCurrentPage - 1) * userItemsPerPage;
    const paginatedUserData = DashboardUserData?.slice(userStartIndex, userStartIndex + userItemsPerPage) || [];
    //error
    const [, setErrors] = useState([]);
    //translations
    const { t } = useTranslation();
    //common
    const TAction = t("common.Action");
    const TnoRecordFound = t("common.noRecordFound");
    const TnoUserFound = t("common.noUserFound");
    const Tcancel = t("common.Cancel");
    const Tnew = t("common.New");
    const Tadd = t("common.Add");
    const Tupdate = t("common.Update");
    const Tstatus = t("common.status");
    const Tsave = t("common.Save");
    const Tdelete = t("common.Delete");

    const TreactivateAccount = t("clientPage.reactivateAccount");
    const TreactivateClientConfirmation = t("clientPage.reactivateClientConfirmation");
    const TDashboard = t("common.Dashboard");
    const TInvite = t("common.Invite");
    const TdropDownDefaultSelect = t("common.dropDownDefaultSelect");
    //Primary Fields
    const TdashboardDetails = t("dashboardAddUpdate.dashboardDetails");
    const Ttitle = t("dashboardAddUpdate.dashboardFields.title");
    const Tlocal = t("dashboardAddUpdate.dashboardFields.titleLocal");
    const TtitleEnglish = t("dashboardAddUpdate.dashboardFields.titleEnglish");
    const TclientName = t("dashboardAddUpdate.dashboardFields.clientName");
    const TlocalClientName = t("dashboardAddUpdate.dashboardFields.localClientName");
    const TclientNameEnglish = t("dashboardAddUpdate.dashboardFields.clientNameEnglish");
    const TdashboardGroupID = t("dashboardAddUpdate.dashboardFields.dashboardGroupID");
    const TworkspaceName = t("dashboardAddUpdate.dashboardFields.workspaceName");
    const TworkspaceID = t("dashboardAddUpdate.dashboardFields.workspaceID");
    const TreportName = t("dashboardAddUpdate.dashboardFields.reportName");
    const TreportID = t("dashboardAddUpdate.dashboardFields.reportID");
    const TRLS = t("dashboardAddUpdate.dashboardFields.RLS");
    const TattachImage = t("dashboardAddUpdate.dashboardFields.attachImage");
    const TservicePrincipal = t("dashboardAddUpdate.dashboardFields.servicePrincipal");
    //placeholder
    const TtitlePH = t("dashboardAddUpdate.dashboardPlaceHolder.titlePH");
    const TtitleLocalPH = t("dashboardAddUpdate.dashboardPlaceHolder.titleLocalPH");
    const TtitleEnglishPH = t("dashboardAddUpdate.dashboardPlaceHolder.titleEnglishPH");
    const TclientNamePH = t("dashboardAddUpdate.dashboardPlaceHolder.clientNamePH");
    const TlocalClientNamePH = t("dashboardAddUpdate.dashboardPlaceHolder.localClientNamePH");
    const TclientNameEnglishPH = t("dashboardAddUpdate.dashboardPlaceHolder.clientNameEnglishPH");
    const TworkspaceNamePH = t("dashboardAddUpdate.dashboardPlaceHolder.workspaceNamePH");
    const TworkspaceIDPH = t("dashboardAddUpdate.dashboardPlaceHolder.workspaceIDPH");
    const TreportNamePH = t("dashboardAddUpdate.dashboardPlaceHolder.reportNamePH");
    const TreportIDPH = t("dashboardAddUpdate.dashboardPlaceHolder.reportIDPH");
    //dashboard Validator
    const TtitleErr = t("dashboardAddUpdate.dashboardValidator.titleErr");
    const TtitleLocalErr = t("dashboardAddUpdate.dashboardValidator.titleLocalErr");
    const TtitleEnglishErr = t("dashboardAddUpdate.dashboardValidator.titleEnglishErr");
    const TclientNameErr = t("dashboardAddUpdate.dashboardValidator.clientNameErr");
    const TclientNameLocalErr = t("dashboardAddUpdate.dashboardValidator.clientNameLocalErr");
    const TclientNameEnglishErr = t("dashboardAddUpdate.dashboardValidator.clientNameEnglishErr");
    const TdashboardGroupErr = t("dashboardAddUpdate.dashboardValidator.dashboardGroupErr");
    const TworkspaceIDErr = t("dashboardAddUpdate.dashboardValidator.workspaceIDErr");
    const TreportIDErr = t("dashboardAddUpdate.dashboardValidator.reportIDErr");
    const TStatusErr = t("dashboardAddUpdate.dashboardValidator.statusErr");
    const TservicePrincipalIDErr = t("dashboardAddUpdate.dashboardValidator.servicePrincipalIDErr");
    //dashboardUdt 
    const TgroupNusers = t("dashboardAddUpdate.dashboardUdt.groupNusers");
    const TinviteUsers = t("dashboardAddUpdate.dashboardUdt.inviteUsers");
    const TemailUdt = t("dashboardAddUpdate.dashboardUdt.emailUdt");
    const TroleUdt = t("dashboardAddUpdate.dashboardUdt.roleUdt");
    const TguestEmailUdt = t("dashboardAddUpdate.dashboardUdt.guestEmailUdt");
    const TguestEmailNoteUdt = t("dashboardAddUpdate.dashboardUdt.guestEmailNoteUdt");
    const TAddAsUdt = t("dashboardAddUpdate.dashboardUdt.AddAsUdt");
    const TvalidUntilUdt = t("dashboardList.dashboardTable.ValidUntil");


    useEffect(() => {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) {
            window.location.href = "/Login/KeyStone_Login";
            return;
        } else {
            const extractAccess = JSON.parse(localStorage.getItem('matchedModule'))
            const addAccess = extractAccess.add
            if (!addAccess) {
                navigate('/access-denied')
                return
            }
        }
        const parsedUserInfo = JSON.parse(userInfo);
        initializeDashboard(parsedUserInfo);
    }, []);

    useEffect(() => {
        updateFillLists();
    }, [groupFillList.data, roleFillList.data, ActiveFillList.data, servicePrincipalFillList.data]);

    useEffect(() => {
        if (debouncedValue) {
            SearchUserAndADGroup(debouncedValue);
        }
    }, [debouncedValue]);

    useEffect(() => {
        return () => {
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
        };
    }, []);

    // Function to initialize dashboard details
    const initializeDashboard = (parsedUserInfo) => {
        if (location.state?.dashboardID) {
            getDashboardDetails(location.state.dashboardID);
        }

        GetUserShareAccess();

        const ownerUser = {
            displayName: parsedUserInfo.userName,
            emailAddress: parsedUserInfo.emailAddress,
            userID: parsedUserInfo.UserID || '',
            validUntil: getNextYearDate(),
            rlsName: '',
            azureGroupID: '',
            azureGroupName: '',
            dashboardRoleID: 3,
            adGroupID: "",
            isDeleted: false
        };

        if (!GroupnUserList.some(user => user.userID === ownerUser.userID)) {
            setGroupnUserList(prevList => [...prevList, ownerUser]);
        }
    };

    // Function to update fill lists
    const updateFillLists = () => {
        if (groupFillList.data) setDashboardGroupFillList(groupFillList.data);
        if (roleFillList.data) setDashboardRoleFillList(roleFillList.data);
        if (ActiveFillList.data) setDashboardActiveFillList(ActiveFillList.data);
        if (servicePrincipalFillList.data) setServicePrincipalFillList(servicePrincipalFillList.data);
    };


    const getDashboardDetails = async (dashboardID) => {
        setIsLoading(true);

        try {
            const data = await axiosGet(`${GetDashboardUrl}?dashboardID=${dashboardID}`);
            if (!data) {
                console.error("Failed to fetch group data: No data found.");
                return;
            }
            setDashboardFields(data);
            setGroupnUserList(processDashboardUsers(data.dashboardUserGroup));

            if (!dashboardID) {
                addOwnerUserToList();
            }
        } catch (error) {
            console.error("Error fetching group data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const setDashboardFields = (data) => {
        console.log('data setDashboardFields', data);
        setTitleEnglish(data.title);
        setTitleLocal(data.localTitle);
        setClientNameEnglish(data.clientName);
        setClientNameLocal(data.localClientName);
        setDashboardGroupID(data.dashboardGroupID);
        setWorkspaceName(data.workspaceName);
        setWorkspaceID(data.workspaceID);
        setReportName(data.reportName);
        setReportID(data.reportID);
        setField1(data.field1);
        setField2(data.field2);
        setImageFileName(data.imageFileName);
        setImagePath(data.imagePath);
        setIsRLS(data.isRLS);
        setStatus(data.status ? 1 : 0);
        setServicePrincipalID(data.servicePrincipalID);

    };

    const processDashboardUsers = (dashboardUsers) => {
        return (dashboardUsers || []).map(user => ({
            ...user,
            isDeleted: user.isDeleted ?? false,
            rlsName: user.dashboardRLS || '',
            isMailView: true,
            validUntil: user.validUntil ? moment(user.validUntil, 'DD-MM-YYYY').format('YYYY-MM-DD') : user.validUntil
        }));
    };

    const addOwnerUserToList = () => {
        const userInfo = localStorage.getItem("userInfo");
        if (!userInfo) return;

        const parsedUserInfo = JSON.parse(userInfo);
        const ownerUser = {
            displayName: parsedUserInfo.userName,
            emailAddress: parsedUserInfo.emailAddress,
            userID: parsedUserInfo.UserID || '',
            validUntil: getNextYearDate(),
            rlsName: '',
            azureGroupID: '',
            azureGroupName: '',
            dashboardRoleID: 3,
            adGroupID: "",
            isDeleted: false
        };

        setGroupnUserList(prevList => {
            return prevList.some(user => user.emailAddress === ownerUser.emailAddress)
                ? prevList
                : [...prevList, ownerUser];
        });
    };
    const handleChangeSearch = (e) => {
        const rawValue = e.target.value;
        const trimmedValue = rawValue.trim();
        setInputValue(rawValue);
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }
        if (trimmedValue.length < 3) {
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
            searchRequestIdRef.current += 1;
            setDebouncedValue('');
            setDashboardUserData([]);
            setUserCurrentPage(1);
            setIsUserLoading(false);
            return;
        }
        setTypingTimeout(
            setTimeout(() => {
                setDebouncedValue(trimmedValue);
            }, 350)
        );
    };
    const GetUserShareAccess = async () => {
        try {
            const response = await axiosGet(GetUserShareAccessUrl);
            console.log(response);
            if (response) {
                setCanShareClient(response.canShareClient);
                setCanShareColliers(response.canShareColliers);
            } else {
                console.error("Failed to fetch GetDashboardUsers: No data found.");
            }
        } catch (error) {
            console.error("Error fetching GetDashboardUsers:", error);
        }
    };
    const handleValidUntil = async (e, i, _data) => {
        const updatedList = [...DashboardUserData];
        updatedList[i] = {
            ...updatedList[i],
            validUntil: e.target.value
        };
        const today = moment().format('YYYY-MM-DD');
        const selectedDate = moment(e.target.value, 'YYYY-MM-DD');
        if (selectedDate.isBefore(today, 'day')) {

            showToast('error', "You can not select past date");
        } else {

            setDashboardUserData(updatedList);
        }
    }

    const handleValidDateChangeEvent = async (e, index, data) => {
        setIsUDTUserDataChanged(true)
        const updatedList = [...GroupnUserList];
        updatedList[index] = {
            ...updatedList[index],
            validUntil: e.target.value
        };
        const today = moment().format('YYYY-MM-DD');
        const selectedDate = moment(e.target.value, 'YYYY-MM-DD');

        if (selectedDate.isBefore(today, 'day')) {
            setErrors(prev => ({
                ...prev,
                [`${data.userID}-validUntil`]: 'Date cannot be in the past.'
            }));
            showToast('error', "You can not select past date");
        } else {
            setErrors(prev => ({
                ...prev,
                [`${data.userID}-validUntil`]: false
            }));
            setGroupnUserList(updatedList);
        }

    }

    const SearchUserAndADGroup = async (searchUserKeyword) => {
        const trimmedKeyword = searchUserKeyword?.trim() || "";
        if (trimmedKeyword.length < 3) {
            setDashboardUserData([]);
            setUserCurrentPage(1);
            setIsUserLoading(false);
            return;
        }
        if (searchAbortControllerRef.current) {
            searchAbortControllerRef.current.abort();
        }
        const abortController = new AbortController();
        searchAbortControllerRef.current = abortController;
        const requestId = ++searchRequestIdRef.current;

        setIsUserLoading(true);
        setDashboardUserData([]);
        setUserCurrentPage(1);
        try {
            const encodedKeyword = encodeURIComponent(trimmedKeyword);
            const response = await axiosGet(
                `${SearchUserAndADGroupUrl}?keyword=${encodedKeyword}&ServicePrincipalID=${ServicePrincipalID ? ServicePrincipalID : 0}&DashboardID=${dashboardID ? dashboardID : 0}`,
                null,
                { signal: abortController.signal }
            );
            if (requestId !== searchRequestIdRef.current || abortController.signal.aborted) {
                return;
            }
            if (Array.isArray(response)) {
                const nextYearDate = getNextYearDate();
                const updatedData = response.map((row) => ({
                    ...row,
                    isAdded: 0,
                    validUntil: nextYearDate
                }));
                setDashboardUserData(updatedData);
            } else {
                setDashboardUserData([]);
                console.error("Failed to search Users: No data found.");
            }
        } catch (error) {
            if (requestId === searchRequestIdRef.current && !abortController.signal.aborted) {
                console.error("Error Search Users:", error);
            }
        } finally {
            if (requestId === searchRequestIdRef.current && !abortController.signal.aborted) {
                setIsUserLoading(false);
            }
        }
    };

    //add to group user
    const AddtoGroupUsers = async (user) => {
        console.log('userExist', user);

        if (!user.validUntil) {
            return showToast('error', 'Please select valid until date');
        }

        const newUser = createNewUser(user);
        const existingUser = findExistingUser(newUser.emailAddress);

        if (shouldCheckInactiveBeforeAdding(newUser, existingUser)) {
            await checkInactiveAndAddUsers([newUser.emailAddress], [newUser]);
        } else if (existingUser) {
            handleExistingUser(existingUser);
        } else {
            addUserToList(newUser);
        }

        setGroupnUserListErr('');
    };

    const createNewUser = (user) => buildDashboardUserFromSearch(user);

    const findExistingUser = (email) => findExistingDashboardUser(GroupnUserList, email);

    const handleExistingUser = (existingUser) => {
        if (existingUser.isDeleted) {
            updateDeletedUser(existingUser.emailAddress);
            showToast("success", "User Added Successfully");
        } else {
            showToast("success", "User Already Exists");
        }
    };

    const updateDeletedUser = (email) => {
        setGroupnUserList(prevList =>
            prevList.map(user => user.emailAddress.toLowerCase() === email.toLowerCase()
                ? { ...user, isDeleted: false }
                : user
            )
        );

        if (dashboardID) setIsUDTUserDataChanged(true);
    };

    const addUserToList = (newUser) => {
        setGroupnUserList(prevList => [...prevList, newUser]);
        showToast("success", "User Added Successfully");
        if (dashboardID) setIsUDTUserDataChanged(true);
    };

    const inviteSubmit = () => {
        console.log(inviteValidUntil);

        // Validate required fields early and return if any are missing
        if (!inviteEmail) return showToast("error", "Kindly Enter Email Address");
        if (!inviteValidUntil) return showToast("error", "Kindly Enter Valid Until Date");
        if (isRLS == 1 && !inviteRls) return showToast("error", "Kindly Enter Row Level Security Name");

        const emails = processEmails(inviteEmail);
        if (!emails) return; // If invalid emails were found, processEmails already showed the error

        const newUsers = createNewUsers(emails, inviteValidUntil, inviteRls);
        const { duplicateNewUsers, usersToAdd } = partitionInvitedUsers(GroupnUserList, newUsers);

        if (duplicateNewUsers.length > 0) {
            handleDuplicateUsers(duplicateNewUsers);
        }
        if (usersToAdd.length === 0) {
            return;
        }

        checkInactiveAndAddUsers(usersToAdd.map(user => user.emailAddress), usersToAdd);
    };

    const checkInactiveAndAddUsers = async (emails, newUsers) => {
        const { activeUsers, inactiveUsers } = await splitUsersByInactiveStatus(emails, newUsers);
        if (activeUsers.length > 0) {
            addNewUsers(activeUsers);
        }
        if (inactiveUsers.length > 0) {
            setPendingInviteUsers(inactiveUsers);
            setIsReactivateModalOpen(true);
        }
    };

    const handleConfirmReactivateInvite = () => {
        if (pendingInviteUsers.length > 0) {
            addNewUsers(pendingInviteUsers);
        }
        setPendingInviteUsers([]);
        setIsReactivateModalOpen(false);
    };

    const handleCancelReactivateInvite = () => {
        setPendingInviteUsers([]);
        setIsReactivateModalOpen(false);
    };

    const processEmails = (inviteEmail) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emails = inviteEmail.split(',').map(email => email.trim()).filter(email => email);

        const duplicateEmails = [...new Set(emails.filter((email, index) => emails.indexOf(email) !== index))];
        if (duplicateEmails.length > 0) {
            showToast("error", `Duplicate emails found: ${duplicateEmails.join(', ')}`);
            return null;
        }

        const invalidEmails = emails.filter(email => !emailRegex.test(email));
        if (invalidEmails.length > 0) {
            showToast("error", `The following emails are invalid: ${invalidEmails.join(', ')}`);
            return null;
        }

        return emails;
    };

    const createNewUsers = (emails, validUntil, rlsName) => {
        return emails.map(email => ({
            userID: "",
            azureGroupID: "",
            azureGroupName: "",
            emailAddress: email,
            dashboardRoleID: resolveDashboardRoleID(email),
            adGroupID: "",
            isDeleted: false,
            validUntil,
            rlsName
        }));
    };

    const handleDuplicateUsers = (duplicateNewUsers) => {
        duplicateNewUsers.forEach(user => {
            showToast('info', `User ${user.emailAddress} already added.`);
        });
    };

    const addNewUsers = (newUsers) => {
        setGroupnUserList(prevList => mergeInvitedUsersIntoGroupList(prevList, newUsers, 'rlsName'));
        showToast("success", "User Added Successfully");

        if (dashboardID) setIsUDTUserDataChanged(true);

        // Reset form fields
        setGroupnUserListErr('');
        setInviteEmail('');
        setInviteRls('');
        setIsInvite(false);
    };

    const handleRemovefromGroupList = (email) => {
        const updatedList = GroupnUserList.map((item, _i) =>
            item.emailAddress === email ? { ...item, isDeleted: true } : item
        );
        setGroupnUserList(updatedList);
        setRemoveUserModal(false);
        setRemoveUserIndex('');

        showToast("success", "User Removed Successfully")
        if (dashboardID) {
            setIsUDTUserDataChanged(true);
        }
    };

    const toggleRemoveUser = (index) => {
        if (isRemoveUserModal) {
            setRemoveUserModal(false);
            setRemoveUserIndex('')
        } else {
            setRemoveUserIndex(index)
            setRemoveUserModal(true);
        }
    };
    const sendMail = async (dashboardID, userID) => {
        const endpoint = `?dashboardID=${dashboardID}&toUserID=${userID}`;
        setIsLoading(true)
        try {
            const response = await axiosPost(`${SendMailNotificationUrl}${endpoint}`);
            if (response) {
                showToast('success', 'Mail Sent Successfully!');
                setIsLoading(false)
            } else {
                showToast('error', 'Failed to Send Mail.');
                setIsLoading(false)
                console.error("Failed to Send Mail.");
            }
        } catch (error) {
            showToast('error', 'Error Sending Mail.');
            setIsLoading(false)
            console.error("Error Sending Mail:", error);
        }
    }
    const inputValidate = () => {
        let isValid = true;

        resetErrorStates();
        if (!validateTitle()) isValid = false;
        if (!validateClientName()) isValid = false;
        if (!validateDropdown(dashboardGroupID, setDashboardGroupIDErr, TdashboardGroupErr)) isValid = false;
        if (!validateDropdown(workspaceID, setWorkspaceIDErr, TworkspaceIDErr)) isValid = false;
        if (!validateDropdown(reportID, setReportIDErr, TreportIDErr)) isValid = false;
        if (!validateDropdown(Status, setStatusErr, TStatusErr)) isValid = false;
        if (!validateDropdown(ServicePrincipalID, setServicePrincipalErr, TservicePrincipalIDErr)) isValid = false;
        if (isRLS && !validateRLS()) isValid = false;

        return isValid;
    };

    const resetErrorStates = () => {
        setTitleLocalErr('');
        setTitleEnglishErr('');
        setClientNameLocalErr('');
        setClientNameEnglishErr('');
        setDashboardGroupIDErr('');
        setWorkspaceIDErr('');
        setReportIDErr('');
        setStatusErr('');
        setServicePrincipalErr('');
    };

    const validateTitle = () => {
        if (currentLang.toLowerCase() === "en-us") {
            if (!titleEnglish) return setError(setTitleEnglishErr, TtitleErr);
        } else {
            if (!titleEnglish) return setError(setTitleEnglishErr, TtitleEnglishErr);
            if (!titleLocal) return setError(setTitleLocalErr, TtitleLocalErr);
        }
        return true;
    };

    const validateClientName = () => {
        if (currentLang.toLowerCase() === "en-us") {
            if (!clientNameEnglish) return setError(setClientNameEnglishErr, TclientNameErr);
        } else {
            if (!titleEnglish) return setError(setClientNameEnglishErr, TclientNameEnglishErr);
            if (!clientNameLocal) return setError(setClientNameLocalErr, TclientNameLocalErr);
        }
        return true;
    };

    const validateDropdown = (value, setErrorFunc, errorMessage) => {
        if (!value || value === TdropDownDefaultSelect) {
            return setError(setErrorFunc, errorMessage);
        }
        return true;
    };

    const validateRLS = () => {
        if (!GroupnUserList || GroupnUserList.length === 0) {
            return setRlsError('No users selected for Row-Level Security');
        }

        const invalidRLSRows = GroupnUserList.filter(row => !row.rlsName?.trim() || row.rlsName === 'select');
        const invalidValidUntilRows = GroupnUserList.filter(row => !row.validUntil?.trim());

        if (invalidRLSRows.length > 0) return setRlsError('Row Level Security entries not detected');
        if (invalidValidUntilRows.length > 0) return setRlsError('Valid Until entries not detected');

        return true;
    };

    const setError = (setErrorFunc, errorMessage) => {
        setErrorFunc(errorMessage);
        return false;
    };

    const setRlsError = (message) => {
        setGroupnUserListErr(message);
        showToast('error', message);
        return false;
    };
    const SubmitDashboard = async () => {
        console.log('submit start');

        if (!inputValidate()) return;

        console.log('validated');
        setIsLoading(true);

        try {
            const formData = createFormData();
            const response = await axiosPost(InsertDashboardUrl, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            handleResponse(response);
        } catch (error) {
            handleError(error);
        }
    };

    const createFormData = () => {
        const formData = new FormData();

        const fields = {
            titleLocal, titleEnglish, clientNameLocal, clientNameEnglish, dashboardGroupID, workspaceName,
            workspaceID, reportName, reportID, field1, field2, imageFileName, imagePath,
            isRLS, isUDTUserDataChanged: false, status: Status == 1, ServicePrincipalID
        };
        Object.entries(fields).forEach(([key, value]) => {
            formData.append(key, value ?? '');
        });

        GroupnUserList.forEach((data, index) => {
            appendUserToFormData(formData, data, index);
        });
        return formData;
    };

    const appendUserToFormData = (formData, data, index) => {
        const safeValue = (val, defaultVal = '') => val ?? defaultVal;
        const safeInt = (val, defaultVal = 0) => {
            return (val !== undefined && val !== null && val !== '') ? val : defaultVal;
        };
        formData.append(`dashboardGroupAndUsers[${index}].userID`, safeInt(data.userID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].azureGroupID`, safeInt(data.azureGroupID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].azureGroupName`, safeValue(data.azureGroup));
        formData.append(`dashboardGroupAndUsers[${index}].emailAddress`, data.emailAddress);
        formData.append(`dashboardGroupAndUsers[${index}].validUntil`, formatValidUntil(data.validUntil));
        formData.append(`dashboardGroupAndUsers[${index}].dashboardRoleID`, data.dashboardRoleID);
        formData.append(`dashboardGroupAndUsers[${index}].rlsName`, safeValue(data.rlsName));
        formData.append(`dashboardGroupAndUsers[${index}].adGroupID`, safeInt(data.adGroupID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].isDeleted`, data.isDeleted);
    };

    const formatValidUntil = (validUntil) => {
        return validUntil ? moment(validUntil).format('DD-MM-YYYY') : null;
    };

    const handleResponse = (response) => {
        if (response) {
            showToast("success", 'Dashboard Added Successfully');
            setTimeout(() => navigate('/dashboard'), 2000);
        } else {
            showToast("error", "Failed to fetch dashboards: No data found.");
            setIsLoading(false);
        }
    };

    const handleError = (error) => {
        showToast("error", `Error fetching dashboards: ${error}`);
        console.error("Error fetching dashboards:", error);
        setIsLoading(false);
    };
    const updateDashboard = async () => {
        if (!inputValidate()) return;

        setIsLoading(true);

        try {
            const formData = createFormDataNew();
            const endpoint = `?updateDashboardID=${dashboardID}`;
            const response = await axiosPost(`${UpdateDashboardUrl}${endpoint}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            handleResponseNew(response, 'Dashboard Updated Successfully');
        } catch (error) {
            handleErrorNew(error);
        }
    };

    const createFormDataNew = () => {
        const formData = new FormData();

        const fields = {
            titleLocal, titleEnglish, clientNameLocal, clientNameEnglish, dashboardGroupID, workspaceName,
            workspaceID, reportName, reportID, field1, field2, imageFileName, imagePath,
            isRLS, isUDTUserDataChanged, status: Status == 1, ServicePrincipalID
        };

        Object.entries(fields).forEach(([key, value]) => {
            formData.append(key, value ?? '');
        });

        GroupnUserList.forEach((data, index) => {
            appendUserToFormDataNew(formData, data, index);
        });
        return formData;
    };

    const appendUserToFormDataNew = (formData, data, index) => {
        const safeValue = (val, defaultVal = '') => val ?? defaultVal;
        const safeInt = (val, defaultVal = 0) => {
            return (val !== undefined && val !== null && val !== '') ? val : defaultVal;
        };

        formData.append(`dashboardGroupAndUsers[${index}].userID`, safeInt(data.userID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].azureGroupID`, safeInt(data.azureGroupID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].azureGroupName`, safeValue(data.azureGroup));
        formData.append(`dashboardGroupAndUsers[${index}].emailAddress`, data.emailAddress);
        formData.append(`dashboardGroupAndUsers[${index}].validUntil`, formatValidUntilNew(data.validUntil));
        formData.append(`dashboardGroupAndUsers[${index}].dashboardRoleID`, data.dashboardRoleID);
        formData.append(`dashboardGroupAndUsers[${index}].rlsName`, safeValue(data.rlsName));
        formData.append(`dashboardGroupAndUsers[${index}].adGroupID`, safeInt(data.adGroupID, 0));
        formData.append(`dashboardGroupAndUsers[${index}].isDeleted`, data.isDeleted);
    };

    const formatValidUntilNew = (validUntil) => {
        return validUntil ? moment(validUntil).format('DD-MM-YYYY') : null;
    };

    const handleResponseNew = (response, successMessage) => {
        if (response) {
            showToast("success", successMessage);
            setTimeout(() => navigate('/dashboard'), 2000);
        } else {
            showToast("error", "Failed to fetch dashboards: No data found.");
            setIsLoading(false);
        }
    };

    const handleErrorNew = (error) => {
        showToast("error", `Error fetching dashboards: ${error}`);
        console.error("Error fetching dashboards:", error);
        setIsLoading(false);
    };
    //fileUpload
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        console.log(file)
        if (file) {
            const isImage = file.type.startsWith("image/");
            const isSizeValid = file.size <= 10 * 1024 * 1024; // 10 MB limit

            if (!isImage) {
                showToast("error", "Please select a valid image file.");
            } else if (!isSizeValid) {
                showToast("error", "Please select an image file smaller than 10MB.");
            } else {
                setImageFileName(file.name); // Save file name for display purposes
                setImagePath(file);         // Save the file itself for upload
            }
            if (!isImage || !isSizeValid) {
                e.target.value = "";
                setImageFileName(null);
                setImagePath(null);
            }
        }
    };
    const currentLang = JSON.parse(localStorage.getItem("userInfo")).lang;
    const handleDate = useCallback(
        _.debounce((event) => {
            const today = moment().format('YYYY-MM-DD');
            const selectedDate = moment(event, 'YYYY-MM-DD');

            if (selectedDate.isBefore(today, 'day')) {

                showToast('error', "You can not select past date");
            } else {

                setInviteValidUntil(event);
            }
        }, 300), []);

    const shouldShowRemoveIcon = (data) => {
        if (data.isDeleted) return false;
        if (dashboardID) return !(Number(data.dashboardRoleID) === 3 && data.isCreatedBy);
        return Number(data.dashboardRoleID) !== 3;
    };

    const shouldShowMailIcon = (data) => {
        return dashboardID && Number(data.dashboardRoleID) === 2 && data.isMailView;
    };
    const shouldShowImage = imagePath;
    const userRoleID = JSON.parse(localStorage.getItem("userInfo"))?.roleID;
    const inviteText = isInvite ? TinviteUsers : `${Tadd} ${TgroupNusers}`;

    const renderUserRow = (data, i) => (
        <TableRow key={data.userID || data.userPrincipalName || data.email || `${userStartIndex + i}`} sx={{ borderBottom: "2px solid", borderColor: "primary.main" }}>
            <TableCell sx={{ fontWeight: "bold" }}>
                <TextField sx={{ paddingTop: '10px', background: 'none' }}
                    label={data.displayName || data.firstName}
                    value={data.userPrincipalName || data.email}
                    fullWidth disabled />
            </TableCell>
            <TableCell className="text-neutral-7">
                <TextField className="text-neutral-7 padding-top-s margin-left-s"
                    sx={{ width: "80%" }} label={TvalidUntilUdt}
                    fullWidth type="date" value={data.validUntil}
                    onChange={(e) => handleValidUntil(e, userStartIndex + i, data)}
                    required variant="outlined"
                    InputLabelProps={{ shrink: true }}
                />
            </TableCell>
            <TableCell>
                <Button className={canShareColliers ? 'padding-right-s padding-left-s background-primary-dark text-primary-dark margin-right-xs add-dashbaord-btn' : ''}
                    variant="outlined" startIcon={canShareColliers ? <AddIcon /> : <></>}
                    sx={{ fontWeight: "bold", textTransform: "none" }}
                    disabled={!canShareColliers}
                    onClick={(event) => {
                        event.persist();
                        AddtoGroupUsers(data);
                    }}>{TAddAsUdt}
                </Button>
            </TableCell>
        </TableRow>
    );
    return (
        <>
            {isLoading && <Loader />}
            <HeaderBlock left=""
                title={`${dashboardID ? Tupdate : Tnew} ${TDashboard}`}
                leftCenterAlign actionsCenterAlign />

            <Box id="main" className="dashboard">
                <Box className="margin-x-m margin-y-m margin-bottom-none">
                    <Box className="section">
                        <Box className="margin-bottom-m border-light border-radius-soft padding-xs padding-y-base padding-x-base"
                            sx={{ flex: 1 }}>
                            <Typography variant="h6" className="font-size-h5 text-primary-dark margin-bottom-base text-uppercase padding-top-xs">
                                {TdashboardDetails}
                            </Typography>
                            <Box sx={{ display: "flex", gap: 3, mb: 1 }}>
                                {currentLang.toLowerCase() === "en-us" ? (
                                    <TextField className="space-lab label-space-top-bot"
                                        onChange={(e) => {
                                            setTitleEnglish(e.target.value)
                                            setTitleEnglishErr('')
                                        }}
                                        error={TitleEnglishErr != ''} helperText={TitleEnglishErr}
                                        value={titleEnglish} fullWidth
                                        label={Ttitle} placeholder={TtitlePH}
                                        required variant="outlined"
                                        inputProps={{ maxLength: 200 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                ) : <>
                                    <TextField className="space-lab label-space-top-bot"
                                        onChange={(e) => {
                                            setTitleEnglish(e.target.value)
                                            setTitleEnglishErr('')
                                        }}
                                        error={TitleEnglishErr != ''} helperText={TitleEnglishErr}
                                        value={titleEnglish} fullWidth
                                        label={TtitleEnglish} placeholder={TtitleEnglishPH}
                                        required variant="outlined"
                                        inputProps={{ maxLength: 200 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField
                                        className="space-lab label-space-top-bot"
                                        label={Tlocal}
                                        onChange={(e) => {
                                            setTitleLocal(e.target.value);
                                            setTitleLocalErr('');
                                        }}
                                        error={TitleLocalErr !== ''}
                                        value={titleLocal}
                                        fullWidth
                                        helperText={TitleLocalErr}
                                        placeholder={TtitleLocalPH}
                                        required
                                        variant="outlined"
                                        inputProps={{ maxLength: 200 }}
                                        InputLabelProps={{ shrink: true, }}
                                    />
                                </>}
                                <TextField
                                    className="space-lab label-space-top-bot"
                                    label={TdashboardGroupID}
                                    onChange={(e) => {
                                        setDashboardGroupID(e.target.value)
                                        setDashboardGroupIDErr('')
                                    }}
                                    value={dashboardGroupID}
                                    helperText={DashboardGroupIDErr}
                                    error={DashboardGroupIDErr != ''}
                                    select
                                    fullWidth
                                    required
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true, }}
                                >
                                    <MenuItem value="" sx={{ color: "black" }}>
                                        {TdropDownDefaultSelect}
                                    </MenuItem>
                                    {DashboardGroupFillList.map((data) => (
                                        <MenuItem key={data.code} value={data.code}>
                                            {data.description}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>

                            <Box sx={{ gridTemplateColumns: "4f 3f", display: "flex", gap: 3, mb: 1, }}  >
                                {currentLang.toLowerCase() === "en-us" ? (
                                    <TextField className="padding-top-s label-space-top-bot"
                                        sx={{ width: "49%" }}
                                        label={TclientName}
                                        onChange={(e) => {
                                            setClientNameEnglish(e.target.value)
                                            setClientNameEnglishErr('')
                                        }}
                                        error={ClientNameEnglishErr != ''}
                                        helperText={ClientNameEnglishErr}
                                        value={clientNameEnglish}
                                        fullWidth
                                        placeholder={TclientNamePH}
                                        required
                                        variant="outlined"
                                        inputProps={{ maxLength: 100 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                ) : <>
                                    <TextField className="padding-top-s label-space-top-bot"
                                        sx={{ width: "49%" }}
                                        label={TclientNameEnglish}
                                        onChange={(e) => {
                                            setClientNameEnglish(e.target.value)
                                            setClientNameEnglishErr('')
                                        }}
                                        error={ClientNameEnglishErr != ''}
                                        helperText={ClientNameEnglishErr}
                                        value={clientNameEnglish}
                                        fullWidth
                                        placeholder={TclientNameEnglishPH}
                                        required
                                        variant="outlined"
                                        inputProps={{ maxLength: 100 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                    <TextField className="padding-top-s label-space-top-bot"
                                        sx={{ width: "49%" }}
                                        label={TlocalClientName}
                                        onChange={(e) => {
                                            setClientNameLocal(e.target.value)
                                            setClientNameLocalErr('')
                                        }}
                                        error={ClientNameLocalErr != ''}
                                        helperText={ClientNameLocalErr}
                                        value={clientNameLocal}
                                        fullWidth
                                        placeholder={TlocalClientNamePH}
                                        required
                                        variant="outlined"
                                        inputProps={{ maxLength: 100 }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </>}

                            </Box>

                            <Box sx={{ gridTemplateColumns: "4f 3f", display: "flex", gap: 3, mb: 1, }}  >
                                <TextField className="padding-top-s label-space-top-bot"
                                    sx={{ width: "50%" }}
                                    label={TworkspaceName}
                                    onChange={(e) => setWorkspaceName(e.target.value)}
                                    value={workspaceName}

                                    placeholder={TworkspaceNamePH}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField className="padding-top-s label-space-top-bot"
                                    sx={{ width: "50%" }}
                                    label={TworkspaceID}
                                    onChange={(e) => {
                                        setWorkspaceID(e.target.value)
                                        setWorkspaceIDErr('')
                                    }}
                                    required
                                    error={WorkspaceIDErr != ''}
                                    value={workspaceID}
                                    helperText={WorkspaceIDErr}
                                    placeholder={TworkspaceIDPH}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>

                            <Box sx={{ gridTemplateColumns: "4f 3f", display: "flex", gap: 3, mb: 1, }}  >
                                <TextField className="padding-top-s label-space-top-bot"
                                    sx={{ width: "50%" }}
                                    label={TreportName}
                                    onChange={(e) => setReportName(e.target.value)}
                                    value={reportName}
                                    placeholder={TreportNamePH}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField className="padding-top-s label-space-top-bot"
                                    sx={{ width: "50%" }}
                                    label={TreportID}
                                    error={ReportIDErr != ''}
                                    fullWidth
                                    required
                                    onChange={(e) => {
                                        setReportID(e.target.value)
                                        setReportIDErr('')
                                    }}
                                    value={reportID}
                                    placeholder={TreportIDPH}
                                    variant="outlined"
                                    helperText={ReportIDErr}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: "flex", gap: 3, mb: 2 }}>

                                {/* <TextField
                                    sx={{ paddingTop: "10px" }}
                                    label={Tfield1}
                                    fullWidth
                                    onChange={(e) => setField1(e.target.value)}
                                    value={field1}
                                    placeholder={Tfield1PH}
                                    variant="outlined"
                                />
                                <TextField
                                    sx={{ paddingTop: "10px" }}
                                    label={Tfield2}
                                    onChange={(e) => setField2(e.target.value)}
                                    value={field2}
                                    fullWidth
                                    placeholder={Tfield2PH}
                                    variant="outlined"
                                /> */}
                                {shouldShowImage ? (
                                    <>
                                        <TextField
                                            label="Attach Image"
                                            variant="outlined"
                                            sx={{ width: '32%' }}
                                            InputProps={{
                                                startAdornment: (
                                                    imagePath ? (
                                                        <>

                                                            <Link
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    display: 'inline-block',
                                                                }}
                                                                href={imagePath}  // Ensure imagePath is a valid URL
                                                                target="_blank"
                                                                title="View Image"
                                                                className="margin-right-base padding-top-base"
                                                            >
                                                                {imageFileName}  {/* Display image filename */}
                                                            </Link>

                                                            <Tooltip title="Remove">
                                                                <DeleteIcon className="margin-left-s font-size-h4"
                                                                    sx={{
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    onClick={() => {
                                                                        setImagePath(null);  // Clear image path
                                                                        setImageFileName(null);  // Clear image file name
                                                                        setIsAlteredImage(true);  // Mark as altered image
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </>
                                                    ) : null
                                                ),
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <TextField className="padding-top-s"
                                            sx={{ width: "49%", }}
                                            label={TattachImage}
                                            type="file"
                                            accept="image/*"
                                            variant="outlined"
                                            helperText={imageFileName && <p>Selected File: {imageFileName}</p>}
                                            InputLabelProps={{ shrink: true }} // Keeps label visible
                                            inputProps={{
                                                onChange: handleFileChange, // File change handler
                                            }}
                                        />
                                    </>
                                )}
                                <FormControlLabel className=""
                                    control={<Checkbox checked={isRLS} onChange={(e) => {
                                        if (dashboardID) { setIsUDTUserDataChanged(true); }
                                        if (isRLS) {
                                            setIsRLS(e.target.checked)
                                            setInviteEmail('')
                                            setInviteValidUntil('')
                                            setInviteRls('')
                                        } else {
                                            setIsRLS(e.target.checked)
                                        }
                                    }} />}
                                    label={TRLS}
                                />
                            </Box>
                            <Box sx={{ display: "flex", gap: 3, mb: 2 }}>
                                {!(userRoleID === 1 || userRoleID === 3) ?
                                    <></> : <>
                                        <TextField className="space-lab label-space-top-bot"
                                            label={Tstatus}
                                            onChange={(e) => {
                                                setStatus(e.target.value)
                                                setStatusErr('')
                                            }}
                                            value={Status}
                                            helperText={StatusErr}
                                            error={StatusErr !== ''}
                                            select fullWidth required
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        >
                                            {DashboardActiveFillList.map((data) => (
                                                <MenuItem key={data.code} value={data.code}>
                                                    {data.description}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </>
                                }
                                <TextField
                                    className="space-lab label-space-top-bot"
                                    label={TservicePrincipal}
                                    onChange={(e) => {
                                        setServicePrincipalID(e.target.value)
                                        setServicePrincipalErr('')
                                    }}
                                    value={ServicePrincipalID}
                                    helperText={ServicePrincipalIDErr}
                                    error={ServicePrincipalIDErr != ''}
                                    select fullWidth required variant="outlined"
                                    InputLabelProps={{ shrink: true, }}
                                >
                                    <MenuItem value="" sx={{ color: "black" }}>
                                        {TdropDownDefaultSelect}
                                    </MenuItem>
                                    {DashboardServicePrincipalFillList.map((data) => (
                                        <MenuItem key={data.code} value={data.code}>
                                            {data.description}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: 3 }}>
                        {/* Groups & Users Section */}
                        {/* Left Table */}
                        <Box className="border-light border-radius-soft padding-xs padding-y-base padding-x-base"
                            sx={{
                                flex: 1,
                            }}
                        >
                            <Typography variant="h6" className="font-size-h5 text-primary-dark padding-top-s">
                                {TgroupNusers}
                            </Typography>
                            <TableContainer className="display-rec-4">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {/* <TableCell>{TnameUdt}</TableCell> */}
                                            <TableCell className="padding-left-none">{TemailUdt}</TableCell>
                                            <TableCell >{TvalidUntilUdt} <Typography variant="p" className="font-semi-bold text-red-darker">*</Typography></TableCell>
                                            <TableCell sx={{ width: '150px' }}>{TroleUdt} <Typography variant="p" className="font-semi-bold text-red-darker">*</Typography></TableCell>
                                            {isRLS && (<TableCell>{TRLS} <Typography variant="p" className="font-semi-bold text-red-darker">*</Typography></TableCell>)}
                                            <TableCell sx={{ textAlign: 'center' }}>{TAction}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {GroupnUserList.length > 0 ? GroupnUserList.map((data, index) => (

                                            data.isDeleted === true ? null : (
                                                <TableRow key={data.emailAddress} >
                                                    {/* <TableCell>{data.displayName !== '' ? data.displayName : '-'}</TableCell> */}
                                                    <TableCell
                                                        className="padding-left-xs "
                                                        sx={{
                                                            width: "20rem",
                                                            wordWrap: "break-word",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {data.emailAddress}
                                                    </TableCell>
                                                    <TableCell className="padding-top-none margin-top-none">
                                                        
                                                        <TextField className="dashboardTF"
                                                            fullWidth
                                                            type="date"
                                                            value={data.validUntil}
                                                            onChange={(e) => handleValidDateChangeEvent(e, index, data)}
                                                            required
                                                            variant="outlined"
                                                        />
                                                    </TableCell>
                                                    <TableCell className="padding-top-none margin-top-none">
                                                        <TextField className="select-rights padding-none margin-none"
                                                            select
                                                            fullWidth
                                                            required
                                                            disabled={(data.dashboardRoleID == 3) || (data.dashboardRoleID == 2)}
                                                            value={data.dashboardRoleID}
                                                            onChange={(e) => {
                                                                setIsUDTUserDataChanged(true)
                                                                const updatedList = [...GroupnUserList];
                                                                updatedList[index] = {
                                                                    ...updatedList[index],
                                                                    dashboardRoleID: e.target.value
                                                                };
                                                                setGroupnUserList(updatedList);
                                                            }}
                                                            variant="outlined"
                                                        >
                                                            {DashboardRoleFillList.map((role) => (
                                                                <MenuItem key={role.code} value={role.code}>
                                                                    {role.description}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </TableCell>
                                                    {isRLS && (
                                                        <TableCell className="padding-top-none margin-top-none">
                                                            <TextField className="margin-bottom-none"
                                                                sx={{ width: '100px' }}
                                                                fullWidth
                                                                value={data.rlsName}
                                                                onChange={(e) => {
                                                                    setIsUDTUserDataChanged(true)
                                                                    const updatedList = [...GroupnUserList];
                                                                    updatedList[index] = {
                                                                        ...updatedList[index],
                                                                        rlsName: e.target.value // Update RLSName
                                                                    };
                                                                    setGroupnUserList(updatedList);
                                                                }}
                                                                required
                                                                variant="outlined"
                                                            />
                                                        </TableCell>
                                                    )}
                                                    <TableCell sx={{ textAlign: 'center' }} className="padding-top-none margin-top-none">
                                                        {shouldShowRemoveIcon(data) && (
                                                            <Tooltip title="Remove">
                                                                <Icon
                                                                    className='fa-light fa-trash-can padding-top-m font-size-base text-primary'
                                                                    onClick={() => toggleRemoveUser(data.emailAddress)}
                                                                />
                                                            </Tooltip>
                                                        )}

                                                        {shouldShowMailIcon(data) && (
                                                            <Tooltip title="Mail">
                                                                <Icon
                                                                    className='fa-light fa-envelope padding-top-m font-size-base text-danger'
                                                                    onClick={() => sendMail(dashboardID, data.userID)}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )) : (
                                            <TableRow>
                                                <TableCell colSpan={6} sx={{ textAlign: 'center' }}>{TnoUserFound}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Typography defaultValue="Error" variant="p">
                                {GroupnUserListErr}
                            </Typography>

                        </Box>

                        {/* Add Groups & Users */}
                        <Box className="border-light border-radius-soft padding-xs padding-top-s padding-left-s"
                            sx={{
                                flex: 1,
                            }}
                        >
                            <Box className="text-align-center padding-left-s"
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography className="font-size-h5 text-primary-dark padding-top-s" variant="h6" >
                                    {inviteText}
                                </Typography>
                                {!isInvite && (
                                    <Button
                                        className="padding-right-s padding-left-s background-primary-dark text-primary-dark margin-right-xs add-dashbaord-btn"
                                        variant="outlined"
                                        disabled={!canShareClient}
                                        startIcon={<AddIcon />}
                                        onClick={() => setIsInvite(true)}
                                    >
                                        {TinviteUsers}
                                    </Button>
                                )}
                            </Box>
                            {isInvite ? <>
                                <Box className="padding-y-none padding-x-s" sx={{ display: "flex", gap: 3, mb: 3 }}>
                                    <TextField className="padding-top-s margin-top-s"
                                        label={TguestEmailUdt}
                                        onChange={(e) => setInviteEmail(e.target.value)}
                                        value={inviteEmail}
                                        fullWidth
                                        placeholder={TguestEmailNoteUdt}
                                        required
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="outlined"
                                    />
                                    <TextField className="padding-top-s margin-left-s margin-top-s"
                                        sx={{ width: "30%", }}
                                        label={TvalidUntilUdt}
                                        onChange={(e) => handleDate(e.target.value)}
                                        value={inviteValidUntil}
                                        fullWidth
                                        type="date"
                                        required
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {isRLS && (
                                        <TextField
                                            sx={{ paddingTop: '17px', width: "25%", marginLeft: '6px' }}
                                            fullWidth
                                            onChange={(e) => setInviteRls(e.target.value)}
                                            value={inviteRls}
                                            required
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            label="Row Level Security"
                                        />
                                    )}
                                </Box>
                                <Box className="padding-x-s margin-top-xs margin-bottom-s"
                                    sx={{ display: "flex", justifyContent: 'center' }}>
                                    <Button className="margin-right-base "
                                        variant="contained"
                                        color="primary"
                                        onClick={() => inviteSubmit()}
                                    >{TInvite}</Button>
                                    <Button variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            setIsInvite(false)
                                            setInviteEmail('')
                                            setInviteRls('')
                                        }}>{Tcancel}</Button>
                                </Box>
                            </> : <>
                                    <TextField className="dashboardTFPadding"
                                    sx={{ mt: '-5px' }}
                                    fullWidth
                                    placeholder="Search for a person or group (Minimum 3 characters)"
                                    variant="outlined"
                                    value={inputValue}
                                    onChange={handleChangeSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" className="dashboardInputAdornment">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {
                                    isUserLoading ? (
                                        <Box sx={{
                                            top: 0, height: '100%', display: 'flex',
                                            zIndex: 9999, justifyContent: 'center', alignItems: 'center'
                                        }}><CircularProgress /></Box>
                                    ) : (
                                        <>
                                            <TableContainer component={Paper} className="display-rec-4 shadow-0 dashboardTableContainer">
                                                <Table>
                                                    <TableBody>
                                                        {paginatedUserData.length ? (
                                                            paginatedUserData.map(renderUserRow)
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell className="text-align-center text-neutral-7" colSpan={3}>
                                                                    {TnoRecordFound}
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            {totalUserItems > userItemsPerPage && (
                                                <CommonPagination
                                                    currentPage={userCurrentPage}
                                                    totalItems={totalUserItems}
                                                    itemsPerPage={userItemsPerPage}
                                                    onPageChange={setUserCurrentPage}
                                                />
                                            )}
                                        </>
                                    )
                                }
                            </>}
                        </Box>
                    </Box>
                </Box>
                <Box className="row border rounded-1 mt-2 py-4 pt-3 ml-4" sx={{ paddingY: 2 }}>
                    <Box className="action-buttons mt-1" sx={{ display: 'flex', justifyContent: "center", gap: 2 }}>
                        <Button className="text-capitalize border-radius-soft	padding-right-s padding-left-s text-primary-dark background-primary-dark padding-y-xs padding-x-s"
                            variant="outlined"
                            sx={{
                                borderColor: '#25408f',
                                color: '#25408f',
                                paddingY: 1,
                                paddingX: 4,
                                textTransform: 'capitalize',
                                borderRadius: 1,
                            }}
                            onClick={() => {
                                if (dashboardID != null && dashboardID != undefined && dashboardID != '' && dashboardID > 0) {
                                    updateDashboard()
                                } else {
                                    console.log('submit enter')
                                    SubmitDashboard()
                                }
                            }}
                        >
                            {Tsave}
                        </Button>
                        <Button className="text-capitalize border-radius-soft	padding-right-s padding-left-s text-primary-dark background-primary-dark padding-y-xs padding-x-s"
                            variant="outlined" onClick={() => navigate('/dashboard')}
                        >
                            {Tcancel}
                        </Button>
                    </Box>
                </Box>
            </Box >
            {/* <Dialog
                open={submitModal}
                PaperProps={{
                    style: {
                        borderRadius: "12px",
                        padding: "16px",
                        width: "400px",
                        textAlign: "center",
                    },
                }}
            >
                <DialogTitle>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        style={{ color: "#000959", marginBottom: "8px" }}
                    >
                        {dashboardID ? "Update Dashboard" : "Submit Dashboard"}
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography style={{ fontSize: "14px", color: "#555555", marginBottom: "16px" }}>
                        Are you sure you want to {dashboardID ? "Add" : "Update"} this Dashboard?
                    </Typography>
                </DialogContent>

                <DialogActions style={{ justifyContent: "center", gap: "8px" }}>
                    <Button
                        variant="outlined"
                        startIcon={<Cancel />}
                        onClick={() => toggleSubmitModal()}
                        style={{
                            color: "#000959",
                            borderColor: "#000959",
                            textTransform: "none",
                            borderRadius: "6px",
                        }}
                    >
                        {Tcancel}
                    </Button>
                    {console.log('dashboardID', dashboardID)}
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (dashboardID) {
                                updateDashboard()
                            } else {
                                SubmitDashboard()
                            }
                        }}
                        startIcon={<Delete />}
                        style={{
                            backgroundColor: "#000959",
                            color: "#FFFFFF",
                            textTransform: "none",
                            borderRadius: "6px",
                        }}
                    >
                        {Tsubmit}
                    </Button>
                </DialogActions>
            </Dialog> */}
            <Dialog className="border-radius-soft padding-s text-align-center dashboardDialog"
                open={isRemoveUserModal}
            >
                <DialogTitle>
                    <Typography className="font-semi-bold text-primary-dark margin-bottom-s">
                        {"Remove User"}
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography className="font-size-s text-neutral-7 margin-bottom-base" >
                        Are you sure you want to Remove User from this Group?
                    </Typography>
                </DialogContent>

                <DialogActions className="dialogAction">
                    
                    <Button className="text-primary-dark background-primary-dark border-radius-soft dashboardTextTransformNone"
                        variant="outlined"
                        startIcon={<Cancel />}
                        onClick={() => toggleRemoveUser()}
                    >
                        {Tcancel}
                    </Button>
                    <Button className="text-primary-dark text-neutral-2 background-secondary-dark border-radius-soft dashboardTextTransformNone"
                        variant="contained"
                        onClick={() => handleRemovefromGroupList(removeUserIndex)}
                        startIcon={<Delete />}
                    >
                        {Tdelete}
                    </Button>
                </DialogActions>
            </Dialog >
            <Dialog
                className="border-radius-soft padding-s text-align-center dashboardDialog"
                open={isReactivateModalOpen}
                onClose={handleCancelReactivateInvite}
            >
                <DialogTitle>
                    <Typography className="font-semi-bold text-primary-dark margin-bottom-s">
                        {TreactivateAccount}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography className="font-size-s text-neutral-7 margin-bottom-base">
                        {TreactivateClientConfirmation}
                    </Typography>
                </DialogContent>
                <DialogActions className="dialogAction">
                    <Button
                        className="text-primary-dark background-primary-dark border-radius-soft dashboardTextTransformNone"
                        variant="outlined"
                        startIcon={<Cancel />}
                        onClick={handleCancelReactivateInvite}
                    >
                        {Tcancel}
                    </Button>
                    <Button
                        className="text-primary-dark text-neutral-2 background-secondary-dark border-radius-soft dashboardTextTransformNone"
                        variant="contained"
                        onClick={handleConfirmReactivateInvite}
                    >
                        {TreactivateAccount}
                    </Button>
                </DialogActions>
            </Dialog>
            {ToastComponent}
        </>
    );
};

export default DashboardAdd;
